/**
 * The Redeem Training Key page. A redeem link carries the code in the fragment (`#code=…`), which
 * never reaches a server, a log or a referrer: the page reads it, takes it out of the address at
 * once, and sends it only in the POST body.
 */
export const redeemPath = '/entitlements/redeem'

/** A link that opens the Redeem Training Key page and redeems the code at once. */
export function redeemLink(code: string): string {
  return `${redeemPath}#${new URLSearchParams({ code }).toString()}`
}

/** Redeeming a training key, which every signed-in person may do for themselves. */
export const redeemPermission = 'entitlements.key-redemptions.write'

/** The API's one redeem endpoint, for every kind of key. */
export const redemptionsApi = '/entitlements/v1/redemptions'
